import React, { useEffect, useState, useRef } from "react";
import { Button, Col, Container, Row, Modal } from "react-bootstrap";
import TextInput from "../../../common/TextInput";
import SearchableSingleSelectDropdown from "../../../common/SearchableDropdown";
import MultilineTextBox from "../../../common/MultilineTextBox";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import { PICKLIST_GROUP_NAME, WEB_ROLE } from "../../../common/Constant";
import { STAKEHOLDER_TYPE } from "../../../common/Constant";
import { validateStakeholderContactInfo } from "../../Master/Stakeholders/components/stakeholderValidation";
import Snackbar from "../../../common/Snackbar";
import {
  StachHolderTypes,
  GetHeaderInfo,
  GetMedicalAssistant,
} from "../../../services/StakeholderApi";
import { updateMedicalAssistant } from "../../../services/ScheduleAppointmentApi";

import {
  Form,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
  Tabs,
  Tab,
} from "react-bootstrap";
import { fetchPickListByGroupName } from "../../../services/UserRegistrationApi";
import moment from "moment";
import {
  addStakeholderContact,
  GetStakeholderContactInfo,
  getuserName,
  getUserRoleForPMC,
} from "../../../services/StakeholderApi";
import AccordionComponent from "../../../common/Accordion";
import DataTable from "../../../common/DataTable";
import TagComponent from "../../../common/TagComponent";

interface MedicalAssignmentProps {
  selectedRows: any[];
  onClose: any;
  onSaveSuccess: any;
}
interface Option {
  areaName?: string;
  localeName?: string;
  physicalCity?: string;
  physicalZip?: string;
  physicalState?: string;
  districtName?: string;
  country?: string;
}

const MedicalAssignment = ({
  selectedRows,
  onClose,
  onSaveSuccess,
}: MedicalAssignmentProps) => {
  const [comments, setComments] = useState<string>("");
  const [note, setNote] = useState<string>("");
  const [assignMedicareAssistantOptions, setassignMedicareAssistantOptions] =
    useState<any[]>([]);
  const [medicareAssistant, setMedicareAssistant] = useState<
    string | null | number
  >(null);

  const userID = useSelector((state: RootState) => state.auth.userid);
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [salutationOptions, setSalutationOptions] = useState<any[]>([]);
  const [stakeholderContactID, setStakeholderContactID] = useState<any>("");
  const [salutationTypeId, setSalutationTypeId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailId, setEmailId] = useState<string[]>([]);
  const [phoneNumber, setPhoneNumber] = useState<string[]>([]);
  const [faxNumber, setFaxNumber] = useState<string[]>([]);
  const [contactUserId, setContactUserId] = useState("");
  const [comment, setComment] = useState("");
  const [isActive, setIsActive] = useState<boolean>(true);
  const [isAllowScheduling, setIsAllowScheduling] = useState<boolean>(false);
  const [selectedStakeholderLabel, setSelectedStakeholderLabel] = useState<
    string | null
  >(null);

  const [specalization, setSpecalization] = useState("");
  const [experience, setExperience] = useState("");

  const [userOptions, setUserOptions] = useState<any[]>([]);
  const [contactData, setContactData] = useState<any[]>([]); 
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [selectedContact, setSelectedContact] = useState<any>(null);
  const [showPreviousContacts, setShowPreviousContacts] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [contactDetails, setContactDetails] = useState<any[]>([]);
  const [contactName, setContactName] = useState("");
  const [activeTab, setActiveTab] = useState("contact");
  const [newContactUserID, setNewContactUserID] = useState(null);
  const [isAlreadyUser, setIsAlreadyUser] = useState(true);
  const [userRoleOption, setUserRoleOption] = useState<any[]>([]);
  const [userRole, setUserRole] = useState<string | number | null>(null);
  const [entityName, setEntityName] = useState("");
  const [showEntityName, setShowEntityName] = useState("");
  const [stakeholderTypeId, setStakeholderTypeId] = useState("");
  const [stakeholderLabelTypeId, setStakeholderLabelTypeId] = useState("");
  const [activeKey, setActiveKey] = useState<string | null>("0");
  const [commentss, setCommentss] = useState("");
  const [typeOption, setTypeOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [stakeholderContactDetailKey, setstakeholderContactDetailKey] =
    useState<string | null>("0");

  const [stakeholderContactDetailFormKey, setstakeholderContactDetailFormKey] =
    useState<string | null>("0");

  const params = {
    salutation: {
      groupName: PICKLIST_GROUP_NAME.Salutation_Type,
      triggerById: userID,
    },
    webRole: {
      groupName: PICKLIST_GROUP_NAME.Web_Application_Role,
      triggerById: userID,
    },
  };
  const [fullName, setFullName] = useState("");
  // Import moment

  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const fetchHeaderInfo = async () => {
      try {
        if (selectedRows?.length && selectedRows[0]?.stakeholderId) {
          const responseData = await GetHeaderInfo(
            Number(selectedRows[0].stakeholderId)
          );

          setEntityName(responseData.result.entityname || "");
          setShowEntityName(responseData.result.entityname || "");
          setStakeholderTypeId(String(responseData.result.stakeholdertypeid));
          setStakeholderLabelTypeId(
            String(responseData.result.stakeholdertypeid)
          );
          setComments(responseData.result.comments || "");
          setIsActive(responseData.result.isactive);
        }
      } catch (error) {
        console.error("Error fetching header info:", error);
      }
    };

    fetchHeaderInfo();
  }, [selectedRows]);

  const fetcMedicareListInfo = async () => {
    try {
      if (selectedRows[0]?.caseInfoId) {
        const responseData = await GetMedicalAssistant(
          selectedRows[0]?.caseInfoId
        );

        if (responseData?.isSuccess && Array.isArray(responseData.result)) {
          const formattedOptions = responseData.result.map((item: any) => ({
            value: item.userId,
            label: item.medicalAssistantNames,
          }));
          // setMedicareAssistant(Number(selectedRows[0].medicalAssistantid));
          setassignMedicareAssistantOptions(formattedOptions);
        } else {
          setassignMedicareAssistantOptions([]); // fallback to empty array
        }
      }
    } catch (error) {
      console.error("Error fetching medicare assistant info:", error);
      setassignMedicareAssistantOptions([]);
    }
  };

  useEffect(() => {
    fetcMedicareListInfo();
  }, [selectedRows]); // ✅ rerun when selection changes

  const handleCloseDrawer = () => {
    setShowDrawer(false);
  };

  function formatUserName(name: string): string {
    return (
      name
        .replace(/\(U\)/g, "(") // Replace (U) with just (
        .replace(/\s*\(E\)\s*/g, "") // Remove (E)
        .replace(/;/g, "-") // Replace ; with -
        .trim() + " )"
    ); // Ensure proper closing bracket
  }
  const getUserRole = async () => {
    try {
      const userRoleData = await getUserRoleForPMC();

      type RoleItem = { value: number; label: string };

      const allRoles: RoleItem[] = userRoleData.map(
        (item: { webRoleId: number; webRoleName: string }): RoleItem => ({
          value: item.webRoleId,
          label: item.webRoleName,
        })
      );

      const allowedRoles: string[] = [WEB_ROLE.Medical_Assistant];

      const filteredRoles: RoleItem[] = allRoles.filter((role: RoleItem) =>
        allowedRoles.includes(role.label)
      );

      setUserRoleOption(filteredRoles);

      // ✅ Auto-select default if only one option
      if (filteredRoles.length === 1) {
        setUserRole(filteredRoles[0].value);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getUserRole();
  }, ["Medical Assistant"]);

  const fetchContactUserData = async (isFreshFetch = false) => {
    const userNameData = await getuserName(
      Number(stakeholderTypeId),
      userRole ? userRole : null
    );

    let transformedOptionsuser = userNameData.map(
      (item: { userid: number; userfullname: string }) => ({
        value: item.userid,
        label: formatUserName(item.userfullname),
      })
    );

    // If it's a fresh fetch, do not include any previously edited names
    if (!isFreshFetch && selectedContact?.contactuserid) {
      const isUserAlreadyInList = transformedOptionsuser.some(
        (option: { value: number; label: string }) =>
          option.value === selectedContact.contactuserid
      );

      if (!isUserAlreadyInList) {
        transformedOptionsuser.push({
          value: selectedContact.contactuserid,
          label: formatUserName(selectedContact.contactusernameEdit),
        });
      }
    }

    setUserOptions(transformedOptionsuser);
  };

  const selectedUserRoleLabel = userRoleOption.find(
    (role) => role.value === userRole
  )?.label;

  const fetchData = async () => {
    try {
      const salutationData = await fetchPickListByGroupName(params.salutation);
      setSalutationOptions(salutationData || []);

      const data = await GetStakeholderContactInfo(
        Number(selectedRows[0].stakeholderId)
      );

      const formattedData = (data || []).map((item: any) => ({
        ...item,

        isAllowScheduling: item.isAllowScheduling == 1 ? "Yes" : "No",
      }));

      setContactData(formattedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (userRole) {
      fetchContactUserData();
    }
  }, [userRole]);

  useEffect(() => {
    const fetchDropdownOptions = async () => {
      try {
        const response = await StachHolderTypes({
          groupName: "Stakeholder_Types",
          triggerById: Number(loggedInUserid),
        });

        const formattedOptions = response.result.map((item: any) => ({
          value: String(item.pickListItemId), // Ensure values are strings
          label: item.displayName,
        }));

        setTypeOption(formattedOptions);
      } catch (error) {
        console.error("Error fetching stakeholder types:", error);
        setSnackbarMessage("Error fetching stakeholder types");
        setError("error");
        setSnackbarOpen(true);
      }
    };

    fetchDropdownOptions();
  }, [loggedInUserid]);
  useEffect(() => {
    if (selectedContact) {
      fetchContactUserData();
    }
  }, [selectedContact]);

  const handleAdd = () => {
    setSnackbarOpen(false);
    handleConfirmCancel();
    setShowForm(true);
  };

  const handleCancel = () => {
    setShowModal(true);
  };
  const handleCancelButton = () => {
    setMedicareAssistant(null);
    setComments("");
  };

  const handleConfirmCancel = () => {
    setMedicareAssistant(null);
    setStakeholderContactID("");
    setContactName("");
    setSalutationTypeId("");
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setEmailId([]);
    setPhoneNumber([]);
    setFaxNumber([]);
    setContactUserId("");
    setComment("");
    setIsActive(true);
    setIsAllowScheduling(false);
    setShowForm(false);
    setShowModal(false);
    setstakeholderContactDetailKey("0");
    setcommunicationDetailSubKey("0");
    setCredentialDetailSubKey("0");
    setSelectedContact(null);
    // Close modal after confirmation
  };

  const handleCloseModal = () => {
    setShowModal(false); // Close modal without resetting form
  };

  const isSpecialStakeholder =
    "StakeholderLabel" === STAKEHOLDER_TYPE.QME_Doctor ||
    selectedUserRoleLabel === WEB_ROLE.QME_Doctor;

  const validateContactForm = () => {
    const validationErrors = validateStakeholderContactInfo(
      userRole,
      salutationTypeId,
      firstName,
      emailId,
      phoneNumber,
      faxNumber,
      isSpecialStakeholder,

      specalization, // Pass specialization
      experience, // Pass experience
      "StakeholderLabel",
      selectedUserRoleLabel
    );

    // Call the validation function

    if (validationErrors.length > 0) {
      setSnackbarMessage(validationErrors.join("\n")); // Show error messages directly
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };
  const lastOpenedRef = useRef<number | null>(null);
  const renderAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          activeKey === index.toString() ? (
            item.title
          ) : (
            <>
              {item.title}
              <span className="fw-normal">
                {showEntityName
                  ? ` - ${showEntityName} (${selectedStakeholderLabel})`
                  : ""}
              </span>
            </>
          ),
      }))}
      activeKey={activeKey}
      onSelect={(key) => {
        lastOpenedRef.current = Date.now(); // Set open time
        setActiveKey(key as string);
      }}
    />
  );
  const handleSave = async () => {
    if (validateContactForm()) {
      try {
        const payloadAdd = {
          stakeholderId: selectedRows[0]?.stakeholderId,
          salutationTypeId: salutationTypeId,
          firstName: firstName.trim(),
          middleName: middleName.trim(),
          lastName: lastName.trim(),
          specialization: specalization ? specalization : "",
          // experienceinyears: experience ? experience : "",
          isAllowScheduling: isAllowScheduling ? 1 : 0,
          emailAddress: emailId.length > 0 ? emailId.join(",") : "",
          phoneNumber: phoneNumber.length > 0 ? phoneNumber.join(",") : "",
          faxNumber: faxNumber.length > 0 ? faxNumber.join(",") : "",
          contactUserId: contactUserId ? contactUserId : null,
          defaultWebRoleId: userRole ? userRole : 0,
          comments: comment,
          Isactive: isActive ? 1 : 0,
          createdBy: userID,
        };

        const isUpdate =
          selectedContact?.stakeholdercontactid || stakeholderContactID
            ? true
            : false;

        const response = await addStakeholderContact(payloadAdd);
        if (response.isSuccess) {
          const selectedSalutation = salutationOptions.find(
            (option) => option.value === salutationTypeId
          );
          const salutationLabel = selectedSalutation
            ? selectedSalutation.label
            : "";

          // Construct full name
          const formattedFullName =
            `${salutationLabel} ${firstName.trim()} ${middleName.trim()} ${lastName.trim()}`.trim();

          setFullName(formattedFullName);

          // ✅ Show success message first
          setSnackbarMessage("Contact created successfully.");
          setError("success");
          setSnackbarOpen(true);

          // ✅ Update states
          const newContactId = response.result;
          setStakeholderContactID(newContactId);
          setMedicareAssistant(newContactId);

          // ✅ Refresh dropdown and data
          await fetcMedicareListInfo();
          fetchData();

          // ✅ Close the form after data refresh
          setShowForm(false);
          setstakeholderContactDetailKey("0");
          setcommunicationDetailSubKey("0");
          setCredentialDetailSubKey("0");

          if (isSpecialStakeholder) {
            setShowForm(true); // re-open if special
            fetchData();
            fetchContactUserData();
          } else {
            fetchContactUserData();
          }
        } else {
          setSnackbarMessage("Failed to add or update contact");
          setError("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        setSnackbarMessage(
          "An error occurred while saving contact details. Please try again."
        );
        setError("error");
        setSnackbarOpen(true);
        console.error("Error during API call:", error);
      }
    }
  };
  const handleAssignMedicalAssistant = async () => {
    const payload = {
      subjectQmeScheduleIds: selectedRows
        .map((row) => row.subjectqmescheduleid)
        .join(","),
      medicalAssistantId: Number(medicareAssistant ?? 0),
      notes: commentss || "",
    };
    try {
      const response = await updateMedicalAssistant(payload);
      if (response.isSuccess) {
        handleCancelButton(); // Reset fields
        setSnackbarMessage("Medical Assistant assigned successfully!");
        setError("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          onClose();
          onSaveSuccess();
        }, 800);
      } else {
        setSnackbarMessage(response.message || "Failed to assign assistant");
        setError("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error updating assistant:", error);
      setSnackbarMessage("Error while assigning medical assistant.");
      setError("error");
      setSnackbarOpen(true);
    }
  };

  const stakeholderContactDetailAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={stakeholderContactDetailKey}
      onSelect={(key) => setstakeholderContactDetailKey(key as string)}
    />
  );

  const stakeholderContactDetailFormAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={stakeholderContactDetailFormKey}
      onSelect={(key) => setstakeholderContactDetailFormKey(key as string)}
    />
  );

  const [contactDetailSubKey, setContactDetailSubKey] = useState<string | null>(
    "0"
  );

  const contactDetailSubAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={contactDetailSubKey}
      onSelect={(key) => setContactDetailSubKey(key as string)}
    />
  );
  const [communicationDetailSubKey, setcommunicationDetailSubKey] = useState<
    string | null
  >("0");

  const communicationDetailSubAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={communicationDetailSubKey}
      onSelect={(key) => setcommunicationDetailSubKey(key as string)}
    />
  );
  const [credentialDetailSubKey, setCredentialDetailSubKey] = useState<
    string | null
  >("0");

  const credentialnDetailSubAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={credentialDetailSubKey}
      onSelect={(key) => setCredentialDetailSubKey(key as string)}
    />
  );

  const [showUserDrawer, setShowUserDrawer] = useState(false);

  const openDrawerWithType = () => {
    setShowUserDrawer(true);
    fetchContactUserData();
    setNewContactUserID(null);
  };

  const updateCredentialDropdown = async (id: any) => {
    if (!newContactUserID) return;
    setContactUserId(id);
    setIsAlreadyUser(true);
  };

  const handlePartyDrawerClose = async () => {
    setShowUserDrawer(false);
    await fetchContactUserData(); // optional, or you can also move this into useEffect
  };

  useEffect(() => {
    if (newContactUserID) {
      updateCredentialDropdown(newContactUserID);
    }
  }, [newContactUserID]);

  const clearUserFields = () => {
    if (!isSpecialStakeholder) {
      setSalutationTypeId("");
    }
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setEmailId([]);
    setPhoneNumber([]);
    setFaxNumber([]);
    setContactUserId(""); // Also reset contact user if needed
  };

  useEffect(() => {
    if (isSpecialStakeholder && salutationOptions.length > 0) {
      const drOption = salutationOptions.find(
        (option) => option.label === "Dr."
      );
      if (drOption) {
        setSalutationTypeId(drOption.value);
      }
    }
  }, [isSpecialStakeholder, salutationOptions]);

  return (
    <>
      {/* MedicalAssignment - {selectedRows.length} selected */}
      <div className="d-flex flex-column h-100">
        {!showForm && (
          <>
            <Row className="mb-auto">
              <Col
                sm={10}
                lg={10}
                xl={10}
                xxl={11}
                className="selection_dropdown mt-4"
              >
                <SearchableSingleSelectDropdown
                  label="Assign Medical Assistant"
                  name="medicareAssistant"
                  options={assignMedicareAssistantOptions} // ✅ always array
                  value={medicareAssistant}
                  onChange={(e) => setMedicareAssistant(Number(e.target.value))}
                  selectOption={true}
                />
              </Col>
              <Col
                sm={2}
                lg={2}
                xl={2}
                xxl={1}
                className="d-flex justify-content-end"
              >
                <div className="address_cta_pos_relative mt-4">
                  <button
                    onClick={handleAdd}
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <span className="material-icons me-2">add</span>
                    Add
                  </button>
                </div>
              </Col>
              <Col sm={12} className="mt-3 notemultiline">
                <MultilineTextBox
                  label="Note"
                  style={{ minHeight: "200px" }}
                  name="comments"
                  value={commentss}
                  onChange={(e) => {
                    let value = e.target.value;
                    if (value.startsWith(" ")) return;
                    value = value?.trimStart();
                    value = value.replace(/ {2,}/g, " ");
                    setCommentss(value);
                  }}
                  maxLength={5000}
                />
              </Col>
            </Row>
            <Row className="bottom-fixed-btn">
              <Col
                md={12}
                className="d-flex justify-content-end mb-2 px-1 pe-4"
              >
                <Button
                  variant="outline-info"
                  className="d-flex align-items-center"
                  onClick={handleCancelButton}
                >
                  <span className="material-icons mr-2">close</span> Cancel
                </Button>
                <Button
                  variant="primary"
                  className="ms-3 d-flex align-items-center"
                  onClick={handleAssignMedicalAssistant}
                >
                  <span className="material-icons mx-1">save</span> Save
                </Button>
              </Col>
            </Row>
          </>
        )}

        {showForm && (
          <>
            {renderAccordion([
              {
                title: "Header",
                content: (
                  <div>
                    <Row>
                      <Col sm={9}>
                        <TextInput
                          label="Entity Name"
                          name="entityName"
                          required
                          value={entityName}
                          maxLength={100}
                          onChange={(e) => {
                            setEntityName(e.target.value);
                          }}
                          disabled
                        />
                      </Col>
                      <Col sm={3} className="selection_dropdown">
                        <SearchableSingleSelectDropdown
                          label="Party Type"
                          name="stakeholderTypeId"
                          required
                          options={typeOption}
                          value={stakeholderTypeId}
                          onChange={(
                            e: React.ChangeEvent<HTMLSelectElement>
                          ) => {
                            setStakeholderTypeId(e.target.value);
                          }}
                          disabled
                        />
                      </Col>
                      <Col sm={12} className="mt-4">
                        <MultilineTextBox
                          label="Comments"
                          name="comments"
                          value={commentss}
                          maxLength={1000}
                          onChange={(e) => setCommentss(e.target.value)}
                          disabled
                        />
                      </Col>
                    </Row>
                    <hr />
                  </div>
                ),
              },
            ])}
            {stakeholderContactDetailFormAccordion([
              {
                title: "Contact Details",
                content: (
                  <>
                    <Row className="align-items-center mb-3">
                      <Col sm={4} className="selection_dropdown">
                        <SearchableSingleSelectDropdown
                          label="User Role"
                          name="userRole"
                          value={userRole} // controlled value
                          options={userRoleOption}
                          required={true}
                          onChange={(e) => setUserRole(Number(e.target.value))} // ✅ update state on change
                          disabled
                        />
                      </Col>

                      {/* <Col sm={6} md={4}>
                      <div className="d-flex align-items-center toggle-btn">
                        <span className="me-3 fw-semibold">
                          Is User Already Created
                        </span>
                        <span className="me-2">No</span>
                        <Form.Check
                          type="switch"
                          id="sort-switch"
                          checked={isAlreadyUser}
                          onChange={handleToggleSort}
                        />
                        <span className="ms-2">Yes</span>
                      </div>
                    </Col> */}
                    </Row>

                    {credentialnDetailSubAccordion([
                      {
                        title: "Credential Details",
                        content: (
                          <>
                            <Row>
                              <Col sm={4} className="selection_dropdown">
                                <SearchableSingleSelectDropdown
                                  label="Contact User"
                                  value={contactUserId}
                                  options={userOptions}
                                  onChange={(e) =>
                                    setContactUserId(e.target.value)
                                  }
                                  name="ContactUserId"
                                  disabled={
                                    !isAlreadyUser ||
                                    ("StakeholderLabel" ===
                                      STAKEHOLDER_TYPE.PMC &&
                                      !userRole)
                                  }
                                />
                              </Col>
                              {!isAlreadyUser && (
                                <Col
                                  sm={3}
                                  className="d-flex align-items-center"
                                >
                                  <Button
                                    className="btn btn-primary d-flex align-items-center float-end"
                                    onClick={() => openDrawerWithType()}
                                    disabled={
                                      "StakeholderLabel" ===
                                        STAKEHOLDER_TYPE.PMC && !userRole
                                    }
                                  >
                                    <span className="material-icons mx-1">
                                      add
                                    </span>
                                    Register New User
                                  </Button>
                                </Col>
                              )}

                              <Col sm={12} className="mt-3">
                                <MultilineTextBox
                                  label="Comment"
                                  name="comments"
                                  value={comment}
                                  onChange={(e) => {
                                    const trimmedValue =
                                      e.target.value.trimStart();
                                    setComment(trimmedValue || "");
                                  }}
                                  maxLength={1000}
                                />
                              </Col>
                            </Row>
                            <Row className="mt-2">
                              <div className="col-md-3">
                                <div className="form-check p-2 py-2">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="Isactive"
                                    name="Isactive"
                                    checked={isActive}
                                    onChange={(e) =>
                                      setIsActive(e.target.checked)
                                    }
                                    style={{ cursor: "pointer" }}
                                  />
                                  <label className="form-check-label">
                                    Is Active?{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                </div>
                              </div>
                            </Row>
                          </>
                        ),
                      },
                    ])}

                    {contactDetailSubAccordion([
                      {
                        title: "Details",
                        content: (
                          <>
                            <Row className="mt-1">
                              <Col sm={3} className="selection_dropdown">
                                <SearchableSingleSelectDropdown
                                  label="Salutation"
                                  value={salutationTypeId}
                                  options={salutationOptions}
                                  onChange={(e) =>
                                    setSalutationTypeId(e.target.value)
                                  }
                                  name="Salutationtypeid"
                                  required={true}
                                  disabled={
                                    !!contactUserId || isSpecialStakeholder
                                  }
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="First Name"
                                  name="Firstname"
                                  value={firstName}
                                  onChange={(e) => {
                                    const onlyText = e.target.value.replace(
                                      /[^a-zA-Z]/g,
                                      ""
                                    );
                                    setFirstName(onlyText);
                                  }}
                                  spacesTrim={true}
                                  required={true}
                                  maxLength={30}
                                  disabled={!!contactUserId}
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="Middle Name"
                                  name="Middlename"
                                  value={middleName}
                                  onChange={(e) => {
                                    const onlyText = e.target.value.replace(
                                      /[^a-zA-Z]/g,
                                      ""
                                    );
                                    setMiddleName(onlyText);
                                  }}
                                  spacesTrim={true}
                                  maxLength={20}
                                  disabled={!!contactUserId}
                                />
                              </Col>
                              <Col sm={3}>
                                <TextInput
                                  label="Last Name"
                                  name="Lastname"
                                  value={lastName}
                                  onChange={(e) => {
                                    const onlyText = e.target.value.replace(
                                      /[^a-zA-Z]/g,
                                      ""
                                    );
                                    setLastName(onlyText);
                                  }}
                                  spacesTrim={true}
                                  maxLength={30}
                                  disabled={!!contactUserId}
                                />
                              </Col>
                            </Row>
                            {isSpecialStakeholder && (
                              <Row className="mt-3 align-items-end d-flex align-items-center">
                                <Col sm={6}>
                                  <TextInput
                                    label="Specialization"
                                    name="specialization"
                                    value={specalization}
                                    onChange={(e) =>
                                      setSpecalization(e.target.value)
                                    }
                                    maxLength={200}
                                    required={true}
                                  />
                                </Col>

                                <Col sm={6}>
                                  <div className="form-check ps-2 d-flex align-items-center">
                                    <label
                                      className="form-check-label mb-0 me-3"
                                      htmlFor="Isactive"
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      Allow Scheduling ?
                                    </label>
                                    <input
                                      type="checkbox"
                                      className="form-check-input "
                                      id="Isactive"
                                      name="Isactive"
                                      checked={isAllowScheduling}
                                      onChange={(e) =>
                                        setIsAllowScheduling(e.target.checked)
                                      }
                                      style={{
                                        cursor: "pointer",
                                        marginRight: "6px",
                                      }}
                                    />
                                    <span style={{ minWidth: "30px" }}>
                                      {isAllowScheduling ? "Yes" : "No"}
                                    </span>
                                  </div>
                                </Col>
                              </Row>
                            )}
                          </>
                        ),
                      },
                    ])}

                    {communicationDetailSubAccordion([
                      {
                        title: "Communication Details",
                        content: (
                          <>
                            <Row>
                              <Col sm={4}>
                                <TagComponent
                                  label="Email Address"
                                  value={emailId}
                                  onChange={setEmailId}
                                  required={true}
                                />
                              </Col>
                              <Col sm={4}>
                                <TagComponent
                                  label="Phone Number"
                                  value={phoneNumber}
                                  onChange={(newValues) =>
                                    setPhoneNumber(newValues.map(String))
                                  }
                                  isPhoneOrFax={true}
                                />
                              </Col>
                              <Col sm={4}>
                                <TagComponent
                                  label="Fax No"
                                  value={faxNumber}
                                  onChange={(newValues) =>
                                    setFaxNumber(newValues.map(String))
                                  }
                                  isPhoneOrFax={true}
                                />
                              </Col>
                            </Row>
                          </>
                        ),
                      },
                    ])}
                  </>
                ),
              },
            ])}
            <Modal show={showModal} onHide={handleCloseModal}>
              {/* <Modal.Header closeButton>
                      <Modal.Title>Confirm Cancellation</Modal.Title>
                    </Modal.Header> */}
              <Modal.Body className="fw-bold text-left modelheading">
                <div>Are you sure you want to cancel the form?</div>
                <div style={{ fontWeight: "300" }}>
                  {" "}
                  Any unsaved data will be lost.
                </div>
              </Modal.Body>
              <Modal.Footer className="border-top d-flex justify-content-end bg-light ">
                <Button
                  variant="outline-info"
                  className="d-flex align-items-center"
                  onClick={handleCloseModal}
                >
                  <span className="material-icons mr-2">close</span> Cancel
                </Button>
                <Button
                  variant="primary"
                  className="ms-3 d-flex align-items-center"
                  onClick={handleConfirmCancel}
                >
                  <span className="material-icons mx-1">check</span> Confirm
                </Button>
              </Modal.Footer>
            </Modal>
            <Row className="mt-3 mb-3 bottom-fixed-btn">
              <Col sm={12} className="d-flex justify-content-end">
                <Button
                  variant="outline-info"
                  className="d-flex align-items-center"
                  onClick={handleCancel}
                >
                  <span className="material-icons mr-2">close</span>
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="primary"
                  className="ms-3 d-flex align-items-center"
                  onClick={handleSave}
                >
                  <span className="material-icons mx-1">save</span>Save
                </Button>
              </Col>
            </Row>
          </>
        )}
      </div>
      <Snackbar
        open={snackbarOpen}
        message={snackbarMessage}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
    </>
  );
};

export default MedicalAssignment;
